module.exports = __webpack_public_path__ + "static/default-wp-image-12c1e9f28cf3cb44458440c03fd7f264.jpg";